import { createLog } from '@thesisedu/feature'

const { debug, error, warn } = createLog('feature-video-on-demand-react')
export { debug, error, warn }
